import { SvgIcon } from "@material-ui/core";
import React from "react";

const PerfilIcon = (props) => {
  return (
    <SvgIcon
      style={{
        fontSize: 24,
      }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.36 35.36">
        <circle
          cx="17.68"
          cy="9.3"
          r="9.3"
          transform="translate(-1.26 2.95) rotate(-9.22)"
        />
        <path d="M27.43,18.76a4.4,4.4,0,0,0-4.31,1L20.76,22a4.49,4.49,0,0,1-6.16,0l-2.36-2.23a4.41,4.41,0,0,0-4.32-1A11.22,11.22,0,0,0,0,29.47v3.64a2.24,2.24,0,0,0,2.24,2.25H33.11a2.25,2.25,0,0,0,2.25-2.25V29.47A11.22,11.22,0,0,0,27.43,18.76Z" />
      </svg>
    </SvgIcon>
  );
};

export default PerfilIcon;
